export const STAFF_ROLES = ['ED', 'SDD', 'FDC'];
export const ROLE_LABELS = { ED: 'Executive Director', SDD: 'State Development Director', FDC: 'Field Development Consultant' };
export function staffRole(item) {
  const role = item?.role?.name ?? item?.role;
  return typeof role === 'string' ? role.trim().toUpperCase() : '';
}
export function staffKey(item) { return String(item?.staffId ?? item?._id ?? ''); }
export function staffName(item) {
  const p = item?.personalInfo || {};
  return p.fullName || [p.firstName, p.surname || p.lastName].filter(Boolean).join(' ') || item?.name || 'Unnamed staff';
}
export function staffTerritory(item) {
  return item?.territory?.name || item?.territory?.regionName || item?.territory?.stateName ||
    item?.organization?.regionName || item?.organization?.stateName || 'Unassigned';
}
export function managerKey(item) { return String(item?.organization?.reportsTo?.staffId ?? item?.reportsTo?.staffId ?? ''); }
export function buildReportingTree(staff = []) {
  const people = Array.isArray(staff) ? staff.filter((item) => STAFF_ROLES.includes(staffRole(item)) && staffKey(item)) : [];
  const byId = new Map(people.map((item) => [staffKey(item), { ...item, children: [] }]));
  const roots = [];
  for (const item of byId.values()) {
    const parent = byId.get(managerKey(item));
    const expected = staffRole(item) === 'FDC' ? 'SDD' : staffRole(item) === 'SDD' ? 'ED' : '';
    if (parent && parent !== item && staffRole(parent) === expected) parent.children.push(item);
    else roots.push(item);
  }
  const order = { ED: 0, SDD: 1, FDC: 2 };
  const sort = (nodes) => nodes.sort((a, b) => (order[staffRole(a)] - order[staffRole(b)]) || staffName(a).localeCompare(staffName(b))).forEach((item) => sort(item.children));
  sort(roots);
  return roots;
}
export function validateAssignment({ staff, territory, reason }) {
  if (!staff || !territory) return 'Choose a staff member and territory.';
  const expected = { ED: 'REGION', SDD: 'STATE', FDC: 'AREA' }[staffRole(staff)];
  if (!expected || territory.type !== expected) return `This role requires a ${expected?.toLowerCase() || 'valid'} territory.`;
  if (!reason?.trim()) return 'Enter a reason for the assignment.';
  return '';
}
